"use client";

import React, { useState, useEffect } from "react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Button } from "@/components/ui/button";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { Menu, X } from "lucide-react";
function DesktopNav() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex gap-4">
        <div className="h-4 w-16 bg-muted animate-pulse rounded" />
        <div className="h-4 w-16 bg-muted animate-pulse rounded" />
        <div className="h-4 w-16 bg-muted animate-pulse rounded" />
      </div>;
  }
  return <NavigationMenu viewport={false} className="hidden md:flex">
      <NavigationMenuList className="gap-2">
        {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
            <NavigationMenuLink asChild>
              <Link to={item.href || "#"} className="group inline-flex h-9 w-max items-center justify-center rounded-none bg-transparent px-4 py-2 text-sm font-semibold font-default transition-colors hover:text-secondary focus:text-secondary disabled:pointer-events-none disabled:opacity-50 data-[active=true]:text-secondary relative overflow-hidden text-foreground">
                <span className="relative z-10">{item.label}</span>
                <span className="absolute bottom-1 left-4 right-4 h-[2px] bg-secondary scale-x-0 transition-transform duration-300 origin-left group-hover:scale-x-100" />
              </Link>
            </NavigationMenuLink>
          </NavigationMenuItem>)}
      </NavigationMenuList>
    </NavigationMenu>;
}
function MobileNav() {
  const {
    menuItems,
    loading
  } = useMenu();
  const [isOpen, setIsOpen] = useState(false);
  if (loading) return null;
  return <div className="md:hidden flex items-center">
      <Button variant="ghost" size="icon" onClick={() => setIsOpen(!isOpen)} aria-label="Toggle Menu" className="text-foreground">
        {isOpen ? <X className="size-6" /> : <Menu className="size-6" />}
      </Button>

      {isOpen && <div className="absolute top-full left-0 w-full bg-background border-b border-border shadow-2xl py-6 px-6 flex flex-col gap-6 z-50 animate-in slide-in-from-top-2">
          <div className="flex flex-col gap-4">
            {menuItems.map((item, i) => <div key={item.id} data-index={i}>
                <Link to={item.href || "#"} className="block text-lg font-semibold font-default text-foreground hover:text-secondary transition-colors" onClick={() => setIsOpen(false)}>
                  {item.label}
                </Link>
              </div>)}
          </div>
          <Button className="w-full bg-primary text-primary-foreground hover:bg-primary/90 font-default font-bold h-12 text-base rounded-none" asChild>
            <Link to="/ContactPage" onClick={() => setIsOpen(false)}>
              Richiedi Accesso
            </Link>
          </Button>
        </div>}
    </div>;
}
export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest("a[href]") as HTMLAnchorElement | null;
      if (anchor) {
        const href = anchor.getAttribute("href");
        if (!href) return;
        if (href === "/#") {
          e.preventDefault();
          window.scrollTo({
            top: 0,
            behavior: "smooth"
          });
          return;
        }
        let hash = "";
        if (href.startsWith("#")) {
          hash = href;
        } else if (href.startsWith("/") && href.includes("#")) {
          const [path, hashPart] = href.split("#");
          if (hashPart === "") {
            e.preventDefault();
            window.scrollTo({
              top: 0,
              behavior: "smooth"
            });
            return;
          }
          if (path === "/" || path === window.location.pathname) {
            hash = "#" + hashPart;
          }
        }
        if (hash && hash !== "#") {
          const element = document.querySelector(hash);
          if (element) {
            e.preventDefault();
            element.scrollIntoView({
              behavior: "smooth",
              block: "start"
            });
          }
        }
      }
    };
    document.addEventListener("click", handleAnchorClick);
    return () => document.removeEventListener("click", handleAnchorClick);
  }, []);
  return <section data-section-id="222112" id="header" className={`sticky top-0 z-50 w-full transition-all duration-300 bg-background text-foreground ${isScrolled ? "bg-background/80 backdrop-blur-md border-b border-border shadow-lg" : "bg-background"}`}>
      <div className="container mx-auto px-4 md:px-6 h-20 flex items-center justify-between">
        {}
        <Link to="/HomePage" className="flex-shrink-0 z-10">
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1591142/img/seorussia_corporate_logo.png" alt="SeoRussia Intelligence" className="h-7 w-auto object-contain" />
        </Link>

        {}
        <div className="hidden md:flex flex-1 justify-center">
          <MenuProvider menu_id="91">
            <DesktopNav />
          </MenuProvider>
        </div>

        {}
        <div className="hidden md:flex flex-shrink-0 z-10">
          <Button asChild className="bg-primary text-primary-foreground hover:bg-primary/90 shadow-md font-default font-bold px-6 rounded-none">
            <Link to="/ContactPage">Richiedi Accesso</Link>
          </Button>
        </div>

        {}
        <MenuProvider menu_id="91">
          <MobileNav />
        </MenuProvider>
      </div>
    </section>;
}